export default __webpack_public_path__ + "static/meta-image-dc9ca3a041dfb685ac3eccd7cbd66585.jpg";